import React from 'react'
import { Row } from 'reactstrap'

export function loader () {

    return (
        <Row>
            <div className='custom_load load'>
                <div className='load__icon-wrap'>
                    <svg className='load__icon'>
                        <path fill='#2d9aa6' d='M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z' />
                    </svg>
                </div>
            </div>
        </Row>
    )
}


// WEBPACK FOOTER //
// ./src/components/Loader.js